export default __webpack_public_path__ + "static/media/time-circle.05929707.svg";